import { matchPath, useLocation } from "react-router";

import { usePinnedItems } from "./usePinnedItems";
import { useSideBarItems } from "./useSideBarItems";

export interface LeftBarMatchItem {
    itemKey: string;
    subItemKey?: string;
}

export const useCheckMatchedItem = (): LeftBarMatchItem => {
    const pathname = useLocation().pathname;
    const pinnedApps = usePinnedItems();
    const { addAppItem, sideBarItems } = useSideBarItems();

    let matchedItem: LeftBarMatchItem = { itemKey: "" };

    [...sideBarItems, addAppItem, ...pinnedApps].forEach((item) => {
        if (item.routeName) {
            const isMatch = matchPath(
                {
                    path: item.routeName,
                    end: false
                },
                pathname
            );
            if (isMatch) {
                matchedItem = { itemKey: item.displayName };
                return;
            }
        } else {
            item.subItems?.forEach((subItem) => {
                const isMatch = matchPath(
                    {
                        path: subItem.routeName ?? "",
                        end: false
                    },
                    pathname
                );
                if (isMatch) {
                    matchedItem = { itemKey: item.displayName, subItemKey: subItem.displayName };
                    return;
                }
            });
        }
    });

    return matchedItem;
};
